"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiContractKeyStore = void 0;
/**
 * KeyStores are passed to {@link near!Near} via {@link near!NearConfig}
 * and are used by the {@link signer!InMemorySigner} to sign transactions.
 *
 * @see {@link connect}
 */
class MultiContractKeyStore {
}
exports.MultiContractKeyStore = MultiContractKeyStore;
